import { 
  EMAIL_CAPTURE,
  LEAD_FORM_SUBMIT,
  REDIRECT_TO_CAPTCHA,
  HMAC_INVALID_WEBFORM_SUBMIT,
  CAPTCHA_SUBMIT_SUCCESS,
  RECAPTCHA_BOT_SCORE,
  RECAPTCHA_ASSESSMENT_ID,
  INTERCOM_MESSENGER_OPENED,
  INTERCOM_MESSENGER_CLOSED,
  INTERCOM_MESSAGE_UNREAD_COUNT_CHANGED
} from "@/eventIds";

export const eventIdMap = {
  [EMAIL_CAPTURE]: 8002,
  [LEAD_FORM_SUBMIT]: 8001,
  [REDIRECT_TO_CAPTCHA]: 10000,
  [HMAC_INVALID_WEBFORM_SUBMIT]: 10001,
  [CAPTCHA_SUBMIT_SUCCESS]: 10003,
  [RECAPTCHA_BOT_SCORE]: 10004,
  [RECAPTCHA_ASSESSMENT_ID]: 10005,
  [INTERCOM_MESSENGER_OPENED]: 102000,
  [INTERCOM_MESSENGER_CLOSED]: 102001,
  [INTERCOM_MESSAGE_UNREAD_COUNT_CHANGED]: 102002
}